import 'owl.carousel';
import { Fancybox } from '@fancyapps/ui';
import 'sharer.js/sharer';

import {viewport} from './functions';

import './components/select';
import './components/psle-tabs';
import './components/checkbox';
import './components/forms';
import './components/custom_scripts';
import './components/scroll-to';
import './components/map';
import './components/map-single';
import './components/header';
import Videos from './components/yt-with-cover';

import './luxfriends/components/phone-field';
import './luxfriends/components/previous-url';
import './luxfriends/components/popup';
import './luxfriends/components/copy-link';
import './luxfriends/components/wpcf7';

import './vaubanfort/components/footer';
import './vaubanfort/components/block-bgImage--fixed'; 

import './luxfriends/pages/single-listing';
import './luxfriends/pages/archive-listing';

jQuery(document).ready(function ($) {
    scrollMe($('a[href*="#"]'));

    $(window).on('load', function () {
        let hash = window.location.hash;
        if (hash != '') {
            scrollToEl($(hash));
        }
    });
});

jQuery(document).ready(function ($) {
    var reCaptchaWidth = 302;
    var containerWidth = $('.container').width();
    if(reCaptchaWidth > containerWidth) {
        var reCaptchaScale = containerWidth / reCaptchaWidth;
        $('.g-recaptcha').css({
            'transform':'scale('+reCaptchaScale+')',
            'transform-origin':'left top'
        });
    }
});

jQuery(document).ready(function ($) {
    let videos = new Videos();
    $('.yt-with-cover').each(function () {
        videos.add($(this), $(this).siblings('.yt-cover'));
    })
    videos.loadApi();
});

jQuery(document).ready(function ($) {
    $('.language-menus').click(function () {
        if(viewport().width < 992) {
            let li = $(this).find('li').last();
            li.toggle();
        }
    });
});

jQuery(document).ready(function ($) {
    $('input[type="date"]').on("input",function(){
        if($(this).val().length  >0){
            $(this).addClass("full");
        } else {
            $(this).removeClass("full");
        }
    });
});

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

/*
 * This enables application of JS modules changes in HTML view.
 * Don't remove it!
 */

if (module.hot) {
    module.hot.accept();
}


